export const SET_BRAND = "SET_BRAND";
export const FETCH_BRAND = "FETCH_BRAND"
export const FETCH_BRAND_DATA_LOADING = "FETCH_BRAND_DATA_LOADING"
export const FETCH_BRAND_ERROR = "FETCH_BRAND_ERROR"

